<template>
  <img :src="imageSrc"
       :class="{ loading : isLoading}"
       @load="isLoading = false"
       :loading="lazyload"
       :style="collabStyle">
</template>

<script>
export default {
  name: "ImageLoader",
  props: {
    small: String,
    trueSize: String,
    collabPage: Boolean,
    collabSize: Number,
    lazyload: {
      type: String,
      default: 'lazy'
    }
  },
  data() {
      return {
        imageSrc: this.small,
        isLoading: true,
        imageWidth : null,
        imageHeight: null
      }
  },
  mounted() {
    let img = new Image();
    this.isLoading = true;
    let VueThis = this;
    img.onload = function() {
      if (VueThis.$props.collabPage) {
        VueThis.resizeImage(img);
      }
      VueThis.isLoading= true;
      VueThis.imageSrc = VueThis.trueSize;
    }
    img.src = this.imageSrc;
  },
  computed: {
    collabStyle() {
      return {
        width: this.collabPage ? this.imageWidth : 'inherit',
        height: this.collabPage ? this.imageHeight : 'inherit'
      };
    }
  },
  methods: {
    resizeImage(img) {
      // Get the image element
      // const container = img.parentElement; // Assuming the image is inside a container
      // console.log(container);
      const maxWidth = this.collabSize; // Max width of the container
      const maxHeight = this.collabSize; // Max height of the container

      // Get the natural width and height of the image
      const naturalWidth = img.naturalWidth;
      const naturalHeight = img.naturalHeight;

      // Calculate the aspect ratio of the image
      const aspectRatio = naturalWidth / naturalHeight;

      // Calculate the new width and height based on max width and height constraints
      let newWidth = maxWidth;
      let newHeight = maxWidth / aspectRatio;

      if (newHeight > maxHeight) {
        newHeight = maxHeight;
        newWidth = maxHeight * aspectRatio;
      }

      // Apply the new width and height to the image
      this.imageWidth = `${Math.floor(newWidth)}px` ;
      this.imageHeight = `${Math.floor(newHeight)}px`;
    },
  }
}
</script>

<style>
img {
  width:100%;
  height:100%;
  transition: filter 1s;
}

img.loading {
    filter: blur(8px);
        -webkit-filter: blur(8px);
        -moz-filter: blur(8px);
        -o-filter: blur(8px);
        -ms-filter: blur(8px);
}

.nour img.image1.loading {
    z-index: 15;
    mix-blend-mode: normal;
}
</style>